export default __webpack_public_path__ + "static/media/neuroproteccion_hipotermia_recien_nacidos_encefalopatia_hipoxicoi.9a44c25d.pdf";